//export const baseURL = 'http://localhost:8084/'
//export const baseURL = 'https://callcenterbi.futurespace.es/callcenterbi/api/'
export const baseURL = process.env.VUE_APP_RUTA_API;
// export const baseURL = 'http://localhost:8083/'
// export const baseURL = 'http://localhost:8084/callcenterbi/api/'

export const exampleApi = 'api/example';
